import React, { useRef } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import ReactPlayer from "react-player/lazy";
import useVisibilitySensor from "@rooks/use-visibility-sensor";
import dayjs from "dayjs";

import StarringYouClipPresenter from "presenters/StarringYouClipPresenter";
import Placeholder from "components/Placeholder";
import { appRoutes } from "routes";
import { useTemplateGroupTracking } from "hooks";

import useStyles from "./useStyles";

const StarringYouClip = ({ item, loading = false, playing = false }) => {
  const classes = useStyles();
  const clipRef = useRef(null);
  const { trackClick } = useTemplateGroupTracking(item);
  const { isVisible } = useVisibilitySensor(clipRef, {
    intervalCheck: 50,
    scrollCheck: true,
    resizeCheck: true,
    partialVisibility: false,
  });

  if (loading)
    return (
      <div className={classes.player}>
        <Placeholder variant="rect" ratio="16x9" />
      </div>
    );

  return (
    <NavLink onClick={trackClick} to={appRoutes.templateGroupPath(StarringYouClipPresenter.id(item))} ref={clipRef}>
      <div className={classes.playerWrapper}>
        <ReactPlayer
          height="100%"
          width="100%"
          className={classes.player}
          playing={playing && isVisible}
          loop
          muted
          playsinline
          url={[{ src: StarringYouClipPresenter.animatedThumb(item), type: "video/mp4" }]}
          config={{ file: { attributes: { poster: StarringYouClipPresenter.thumb(item) } } }}
        />
      </div>
      <div className={classes.overlay} />
      <img src={item.titleImage} alt={item.name} className={classes.imageName} />
      <span className={classes.duration}>{dayjs.duration(item.duration, "seconds").format("m:ss")}</span>
    </NavLink>
  );
};

StarringYouClip.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    titleImage: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    duration: PropTypes.number.isRequired,
    attributes: PropTypes.shape({}),
  }),
  playing: PropTypes.bool,
  loading: PropTypes.bool,
};

export default StarringYouClip;
